import { createSelector } from 'reselect';
import { Compare } from '../constants';
import { isCensusView } from './router';
import { getCrimeTypes } from '../reducers/crimeTypes';
import { filter } from 'ramda';

export const getOptions = state => state.options;
export const getTimespan = state => state.options.timespan;
export const getCrimeType = state => state.options.crimeType;
export const getMetric = state => state.options.metric;
export const getCompare = state => state.options.compare;
export const getPrecision = state => state.options.precision;
export const getSelectedCitiesIds = state => state.options.selectedCitiesIds;
export const getSelectedCensusTractsIds = state =>
  state.options.selectedCensusTractsIds;
export const getCustomCompareInterval = state =>
  state.options.customCompareInterval;
export const getCustomTimespanInterval = state =>
  state.options.customTimespanInterval;
export const getSortColumn = state => state.options.sortColumn;
export const getSortReversed = state => state.options.sortReversed;
export const getSortPage = state => state.options.sortPage;
export const getCompChartType = state => state.options.compChartType;

export const getShowPartialData = state => getCompare(state) === Compare.NONE;

export const getSelectedLocationsIds = createSelector(
  isCensusView,
  getSelectedCitiesIds,
  getSelectedCensusTractsIds,
  (censusView, cities, censusTracts) => (censusView ? censusTracts : cities),
);

export const getCensusCrimeTypes = createSelector(getCrimeTypes, crimeTypes =>
  filter(x => x.tract_level === 1, crimeTypes),
);

export const getCityCrimeTypes = createSelector(getCrimeTypes, crimeTypes =>
  filter(x => x.city_level === 1, crimeTypes),
);

export const getSelectedCrimeTypes = createSelector(
  isCensusView,
  getCityCrimeTypes,
  getCensusCrimeTypes,
  (censusView, cityTypes, censusTypes) =>
    censusView ? censusTypes : cityTypes,
);

export const getSafeMetric = createSelector(
  isCensusView,
  getMetric,
  (censusView, metric) => (censusView ? 'total' : metric),
);

export const getSafeCrimeType = createSelector(
  isCensusView,
  getCrimeType,
  getCensusCrimeTypes,
  (censusView, selectedCrimeType, censusCrimeTypes) => {
    if (censusView) {
      let censusCrimeTypeIds = censusCrimeTypes.map(x => x.id);
      return (
        censusCrimeTypeIds.find(x => x === selectedCrimeType) ||
        censusCrimeTypeIds[0]
      );
    }
    return selectedCrimeType;
  },
);



// WEBPACK FOOTER //
// ./src/selectors/options.js